<p-dialog-container>
    <p-dialog-header title="{{ 'UserProfile.UserLicenses.userLicensesHeader' | translate }}"></p-dialog-header>
    <div class="p-dialog-content">
        <div class="font">{{ 'UserProfile.UserLicenses.userLicensesTableHeader' | translate }}</div>
        <div *ngIf="viewAllLicenses$ | async as user">
            <table class="table">
                <th></th>
                <th>{{ 'UserProfile.UserLicenses.ptcHeader' | translate }}</th>
                <th>{{ 'UserProfile.UserLicenses.iaHeader' | translate }}</th>
                <th>{{ 'UserProfile.UserLicenses.rdxHeader' | translate }}</th>

                <tr *ngFor="let item of user.userSubscriptionsBeans">
                    <td class="length" [showOnlyWhenEllipsis]="true" [matTooltip]="formatAccountName(item)">
                        {{ formatAccountName(item) }}
                    </td>
                    <td>{{ formatDate(item?.subscriptionBean?.ptcSubscriptionData?.endDate) }}</td>
                    <td>{{ formatDate(item?.subscriptionBean?.iaSubscriptionData?.endDate) }}</td>
                    <td *ngIf="item.subscriptionBean?.rdxSubscriptionData != null">
                        {{ formatDate(item?.subscriptionBean?.rdxSubscriptionData?.endDate) }}
                    </td>
                </tr>
            </table>
        </div>
    </div>

    <p-dialog-footer [btnConfig]="footerConfig"></p-dialog-footer>
</p-dialog-container>
